import { LtInput } from 'limetray-ui-kit';
import { userManagerConstants } from '../../../../constants/userManagerConstants';
import LtLabel from '../../../../components/LtLabel';

const { labels, placeholders } = userManagerConstants.createRoleModal;

/**
 * RoleBasicDetailsSection
 *
 * Renders the "Basic Information" form fields for role create/edit.
 * Used as a section component inside CreateEditRoleModal → ManagerModal.
 *
 * @param {object}   props
 * @param {object}   props.formData  - Current field values
 * @param {function} props.onChange  - Called with (field, value) on change
 * @param {function} [props.onBlur]   - Called with (field) on input blur
 * @param {object}   props.errors    - Field-level error strings keyed by field name
 */
function RoleBasicDetailsSection({
  formData,
  onChange,
  onBlur = () => {},
  errors = {},
}) {
  return (
    <div className="inputGrid">
      <div className="row col-2">
        {/* ── Role Name ── */}
        <div className="modal-form-field">
          <LtLabel required>{labels.name}</LtLabel>
          <LtInput
            placeholder={placeholders.name}
            value={formData.roleGroupName || ''}
            onChange={(e) => onChange('roleGroupName', e.target.value)}
            onBlur={() => onBlur('roleGroupName')}
            className="modal-form-input"
            data-error={!!errors.roleGroupName}
          />
          {errors.roleGroupName && (
            <span className="modal-field-error">{errors.roleGroupName}</span>
          )}
        </div>

        {/* ── Role Description ── */}
        <div className="modal-form-field">
          <LtLabel required>{labels.description}</LtLabel>
          <LtInput
            placeholder={placeholders.description}
            value={formData.roleGroupDescription || ''}
            onChange={(e) => onChange('roleGroupDescription', e.target.value)}
            onBlur={() => onBlur('roleGroupDescription')}
            className="modal-form-input"
            data-error={!!errors.roleGroupDescription}
          />
          {errors.roleGroupDescription && (
            <span className="modal-field-error">{errors.roleGroupDescription}</span>
          )}
        </div>
      </div>
    </div>
  );
}

export default RoleBasicDetailsSection;
